import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" ref={ref} {...props}>
        <path
            fill="#A8ACBD"
            fillRule="evenodd"
            d="M5.948 11.613C4.32 11.613 3 10.41 3 8.926 3 7.443 4.32 6.24 5.948 6.24c.264 0 .518.035.761.094.496-1.336 1.87-2.302 3.497-2.331L10.243 4h.038c1.926 0 3.514 1.317 3.742 3.016.142-.022.286-.036.435-.036C15.862 6.98 17 8.017 17 9.296c0 1.28-1.138 2.317-2.542 2.317h-8.51Z"
            clipRule="evenodd"
        />
        <path
            fill="#35A1E9"
            fillRule="evenodd"
            d="M6.28 15.889c-.29.67-1.071.98-1.744.69a1.322 1.322 0 0 1-.693-1.74c.29-.67 2.294-1.958 2.294-1.958s.434 2.336.143 3.008Zm4.112 0c-.29.67-1.071.98-1.744.69a1.322 1.322 0 0 1-.693-1.74c.29-.67 2.294-1.957 2.294-1.957s.434 2.335.143 3.007Zm4.113 0a1.33 1.33 0 0 1-1.745.69 1.321 1.321 0 0 1-.693-1.74c.29-.67 2.294-1.957 2.294-1.957s.434 2.335.144 3.007Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
